class DropdownMenu extends HTMLElement {
  constructor() {
    super();

    this.dropdownButtonDesktop = this.querySelector('.dropdown-button-desktop');
    this.desktopDropdown = this.querySelector('.select-dropdown');

    this.dropdownFunctions();
  }

  dropdownFunctions() {
    this.addEventListener('mouseenter', () => {
      this.desktopDropdown.classList.add('is-opened');
    });

    this.addEventListener('mouseleave', () => {
      this.desktopDropdown.classList.remove('is-opened');
    });

    this.desktopDropdown.addEventListener('mouseleave', () => {
      this.desktopDropdown.classList.remove('is-opened');
    });
  }
}

customElements.define('dropdown-menu', DropdownMenu);

class MobileDropDown extends HTMLElement {
  constructor() {
    super();

    this.dropdownButtonMobile = this.querySelector('.dropdown-button-mobile');
    this.mobileDropdown = this.querySelector('.select-dropdown');
    this.chevronIconRight = this.querySelector('.chevronIconRight');
    this.drawerMenu = document.querySelector('nav .drawer__menu');

    this.mobileDropdownFunctions();
  }

  mobileDropdownFunctions() {
    this.addEventListener('click', (event) => {
      this.mobileDropdown.classList.toggle('is-opened');

      if (!this.dropdownButtonMobile.contains(event.target) && !this.mobileDropdown.contains(event.target) && !this.mobileDropdown.classList.contains('is-opened')) {
        this.mobileDropdown.classList.remove('is-opened');
      }

      this.chevronIconRight.classList.toggle('rotate-left');
    });

    this.drawerMenu.addEventListener('click', () => {
      if (parseInt(this.drawerMenu.getAttribute('data-sliderule-pane')) >= 1) {
        this.mobileDropdown.classList.remove('is-opened');

        if (this.chevronIconRight.classList.contains('rotate-left')) {
          this.chevronIconRight.classList.remove('rotate-left');
        }
      }
    });
  }
}

customElements.define('mobile-dropdown-menu', MobileDropDown);